import {DropdownOptions} from '~/types/general';

export const APPLICATIONS_FORMS_TYPES = {
  STUDENT: 'student',
  AMBASSADOR: 'ambassador',
};

export const SCHOOL_LIST: DropdownOptions = [
  {
    label: 'National University of Singapore',
    value: 1,
  },
  {
    label: 'National Technological University',
    value: 2,
  },
  {
    label: 'Yale-NUS',
    value: 3,
  },
];
